
export default class InformationSlider {

	static getHolderSelectors = () => ['.information-slider-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		let self = this;
		let lastWindowSize = window.innerWidth;

		this.#resizeSlider();

		window.addEventListener('resize', function(event) {
			if ((lastWindowSize < 576 && window.innerWidth >= 576) || (lastWindowSize >= 576 && window.innerWidth < 576)) {
				lastWindowSize = window.innerWidth;
				self.#resizeSlider();
			}
		}, true);
	}

	#resizeSlider() {
		let splide;
		let self = this;

		if (window.innerWidth < 576) {
			splide = new Splide(this.#holderElement.querySelector('.splide'), {
				type: 'loop',
				perPage: 1,
				gap: '0.75rem',
				padding: '0.75rem',
				width: '100vw',
				fixedWidth: 'calc(100vw - 1.5rem)',
				fixedHeight: '18rem',
				pagination: false,
			}).mount();
		} else {
			splide = new Splide(this.#holderElement.querySelector('.splide'), {
				type: 'loop',
				gap: '2.5rem',
				padding: { left: '15rem'},
				width: '100vw',
				fixedWidth: '25.25rem',
				fixedHeight: '18rem',
				pagination: false,
			}).mount();
		}

		this.#holderElement.querySelectorAll('.category').forEach(category => {
			category.addEventListener("click", ()=>{
				this.#holderElement.querySelector('.filter-tab').querySelector('.is-active')?.classList.remove('is-active');
				category.classList.add('is-active');

				let splideLabel = this.#holderElement.querySelector('.splide')?.querySelector(`.${category.dataset.category}`)?.getAttribute('aria-label');
				if (splideLabel) {
					splide.go(parseInt(splideLabel.split(' of ')[0]) - 1);
				}
			});
		});

		splide.on( 'active', function () {
			let activeCategory = self.#holderElement.querySelector('.splide__track')?.querySelector('.is-active')?.dataset.category.split(' ')[0];
			self.#holderElement.querySelector('.filter-tab').querySelector('.is-active')?.classList.remove('is-active');
			self.#holderElement.querySelector('.filter-tab').querySelector(`.${activeCategory}`)?.classList.add('is-active');
		} );
	}

}
